import { makeVar } from '@apollo/client/cache';
import { Organization } from 'models/organization';

export const currentOrgVar = makeVar<Organization>({} as Organization);
